import Helper from "./Helper";

class SliderArrowCenter {
  constructor(config = {}) {
    const {
      outerWrapperSelector,
      heightItem,
      swiperInstances,
      sliderBreakpointMax,
      sliderBreakpointMin,
      alignFrom
    } = config;
    this.outerWrapperSelector = outerWrapperSelector;
    this.heightItem = heightItem;
    this.swiperInstances = swiperInstances;
    this.sliderBreakpointMax = sliderBreakpointMax;
    this.sliderBreakpointMin = sliderBreakpointMin;
    this.alignFrom = alignFrom || 'top';

    this.previousScreenWidth = window.innerWidth;

    this.sliders = document.querySelectorAll(this.outerWrapperSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);

    if (this.sliders) {
      this.bindEvents();
    }
  }

  bindEvents() {
    if (this.sliderBreakpointMin != null && this.sliderBreakpointMax != null) {
      if (this.previousScreenWidth >= this.sliderBreakpointMin && this.previousScreenWidth < this.sliderBreakpointMax) {
        this.calculateArrowPosition();
      }
    } else if (this.sliderBreakpointMax != null) {
      if (this.previousScreenWidth < this.sliderBreakpointMax) {
        this.calculateArrowPosition();
      }
    } 
    
    window.addEventListener("resize", () => {
      const vw = window.innerWidth;

      if (this.sliderBreakpointMin != null && this.sliderBreakpointMax != null) {
        if (vw >= this.sliderBreakpointMin && vw < this.sliderBreakpointMax) {
          this.calculateArrowPosition();
        }
      } else if (this.sliderBreakpointMax != null) {
        if (vw < this.sliderBreakpointMax) {
          this.calculateArrowPosition();
        }
      } 

      this.previousScreenWidth = vw;
    });

    /*
    this.swiperInstances.forEach((slider, index) => {
      slider.on('slideChangeTransitionEnd', () => {
        this.handleScroll();
      });
    });
    */
  }

  calculateArrowPosition() {
    this.slidersArray.forEach((slider, index) => {
      const slideItems = slider.querySelectorAll(this.heightItem);
      const sliderArrowWrapper = slider.querySelector(".swiper-prev-next-wrap");

      // get the max height of all items to center the arrows
      let slideHeight = 0;
      slideItems.forEach((item, index) => {
        const itemHeight = item.offsetHeight;
        if (itemHeight > slideHeight) {
          slideHeight = itemHeight;
        }
      });
      
      if (this.alignFrom == "top") {
        sliderArrowWrapper.style.top = "calc(" + slideHeight + "px / 2)";
      } else if (this.alignFrom == "bottom") {
        sliderArrowWrapper.style.bottom = "calc(" + slideHeight + "px / 2)";
        sliderArrowWrapper.style.top = "auto";
      }
      
    });
  }

}

export default SliderArrowCenter;
